import { render, staticRenderFns } from "./UserRegistrationND.vue?vue&type=template&id=b8a534ac&scoped=true"
import script from "./UserRegistrationND.vue?vue&type=script&lang=js"
export * from "./UserRegistrationND.vue?vue&type=script&lang=js"
import style0 from "./UserRegistrationND.vue?vue&type=style&index=0&id=b8a534ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a534ac",
  null
  
)

export default component.exports